import Ticket from './styles'

export default Ticket